import { jsx as s, jsxs as C } from "react/jsx-runtime";
import { useState as S, useMemo as T, useCallback as Tt } from "react";
import { Button as Q } from "../Button/Button.js";
import "../Button/ButtonBase.js";
import "../Button/theme.js";
import { Actions as bt } from "./Actions.js";
import { MAX_CAMPAIGN_PERIOD_DAYS as kt } from "./constants.js";
import { Header as Ct } from "./Header.js";
import { Month as x } from "./Month.js";
import { SelectionSummary as It } from "./SelectionSummary.js";
import { periodDatePickerTheme as f } from "./theme.js";
import { Trigger as Et } from "./Trigger.js";
import { MONTHS as tt, DEFAULT_QUICK_PERIODS as Lt } from "./types.js";
import { Popover as qt, PopoverContent as yt } from "../Popover/index.js";
import { cn as Ot } from "../../utils/cn.js";
const Jt = ({
  startDate: F,
  endDate: I,
  onDateChange: E,
  minDate: l,
  maxDate: o,
  visibleMinDate: b,
  visibleMaxDate: k,
  minPeriodDays: M = 10,
  maxPeriodDays: m = kt,
  showTodayQuickSelect: q = !0,
  showQuickPeriods: y = !0,
  quickPeriods: et = Lt,
  open: O,
  onOpenChange: nt,
  showTrigger: H = !0,
  showSelectionPreview: rt = !0,
  showDaysCount: j = !0,
  showMonthYearSelector: ot = !0,
  autoApply: L = !1,
  align: lt = "start",
  side: st = "right",
  sideOffset: at = 8
}) => {
  const [it, ct] = S(!1), _ = O !== void 0, ut = _ ? O : it, Y = (t) => {
    _ || ct(t), nt?.(t);
  }, [r, A] = S(() => {
    const t = new Date(F), e = b ?? l, n = k ?? o;
    return e && t < new Date(e.getFullYear(), e.getMonth(), 1) ? new Date(e.getFullYear(), e.getMonth(), 1) : n && t > new Date(n.getFullYear(), n.getMonth(), 1) ? new Date(n.getFullYear(), n.getMonth(), 1) : t;
  }), [p, N] = S(null), [a, g] = S(null), [v, h] = S(null), [ft, z] = S(null), R = a ?? F, U = v ?? I, $ = T(() => {
    const t = Math.abs(
      U.getTime() - R.getTime()
    );
    return Math.round(t / (1e3 * 60 * 60 * 24)) + 1;
  }, [R, U]), B = (t) => t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }), D = (t) => t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  }), G = (t, e) => {
    const n = new Date(t, e, 1), c = new Date(t, e + 1, 0).getDate();
    let d = n.getDay() - 1;
    d < 0 && (d = 6);
    const w = [];
    for (let u = 0; u < d; u++)
      w.push(null);
    for (let u = 1; u <= c; u++)
      w.push(new Date(t, e, u));
    return w;
  }, gt = T(() => G(r.getFullYear(), r.getMonth()), [r]), ht = T(() => {
    const t = new Date(
      r.getFullYear(),
      r.getMonth() + 1,
      1
    );
    return G(t.getFullYear(), t.getMonth());
  }, [r]), K = new Date(
    r.getFullYear(),
    r.getMonth() + 1,
    1
  ), dt = T(() => {
    const t = b ?? l, e = k ?? o, n = t?.getFullYear(), i = e?.getFullYear(), c = n != null && !isNaN(n) ? n : r.getFullYear() - 10, d = i != null && !isNaN(i) ? i : r.getFullYear() + 10, w = [];
    if (!isNaN(c) && !isNaN(d))
      for (let u = c; u <= d; u++) w.push(u);
    return w;
  }, [b, k, l, o, r]), pt = T(() => {
    const t = b ?? l;
    if (!t) return !0;
    const e = r.getFullYear() * 12 + r.getMonth(), n = t.getFullYear() * 12 + t.getMonth();
    return isNaN(n) ? !0 : e > n;
  }, [b, l, r]), Mt = T(() => {
    const t = k ?? o;
    if (!t) return !0;
    const e = r.getFullYear() * 12 + r.getMonth() + 1, n = t.getFullYear() * 12 + t.getMonth();
    return isNaN(n) ? !0 : e <= n;
  }, [k, o, r]), V = Tt(
    (t) => {
      if (p !== "end" || !a) return !1;
      if (t < a) return !0;
      const e = Math.ceil(
        (t.getTime() - a.getTime()) / (1e3 * 60 * 60 * 24)
      ) + 1;
      return e < M || e > m;
    },
    [p, a, M, m]
  ), mt = (t, e) => {
    A(new Date(e, t, 1));
  }, Nt = (t) => {
    A((e) => {
      const n = new Date(e);
      return t === "prev" ? n.setMonth(n.getMonth() - 1) : n.setMonth(n.getMonth() + 1), n;
    });
  }, W = (t) => {
    const e = a ?? F;
    let n = null;
    if (p === "end" ? n = ft ?? null : n = v ?? I, !e || !n) return !1;
    const i = t.getTime(), c = e.getTime(), d = n.getTime();
    return i > Math.min(c, d) && i < Math.max(c, d);
  }, X = (t) => {
    const e = a ?? F;
    return e && t.toDateString() === e.toDateString();
  }, J = (t) => {
    if (p === "end" && !v) return !1;
    const e = v ?? I;
    return e && t.toDateString() === e.toDateString();
  }, P = (t) => {
    if (!p || p === "start")
      g(t), h(null), N("end");
    else {
      const e = a;
      let n = e, i = t;
      t < e && (n = t, i = e);
      const c = Math.ceil(
        (i.getTime() - n.getTime()) / (1e3 * 60 * 60 * 24)
      ) + 1;
      if (c < M || c > m)
        return;
      g(n), h(i), N(null), L && (E(n, i), Y(!1), g(null), h(null));
    }
  }, vt = () => {
    a && v && E(a, v), Y(!1), g(null), h(null), N(null);
  }, Ft = (t) => {
    if (t < M || t > m) return;
    const e = a ?? F;
    let n = new Date(e);
    n.setDate(n.getDate() + t - 1), o && n > o && (n = new Date(o)), !(l && e < l) && (g(e), h(n), N(null), L && (E(e, n), Y(!1), g(null), h(null)));
  }, Yt = () => {
    Y(!1), g(null), h(null), N(null);
  }, wt = `${tt[r.getMonth()]} ${r.getFullYear()}`, St = `${tt[K.getMonth()]} ${K.getFullYear()}`, Z = () => /* @__PURE__ */ C("div", { className: f.popover.root.content, children: [
    /* @__PURE__ */ s(
      Ct,
      {
        viewDate: r,
        onNavigate: Nt,
        showMonthYearSelector: ot,
        onMonthYearChange: mt,
        yearRange: dt,
        disablePrev: !pt,
        disableNext: !Mt
      }
    ),
    /* @__PURE__ */ C("div", { className: "flex gap-8", children: [
      /* @__PURE__ */ s(
        x,
        {
          days: gt,
          monthLabel: wt,
          minDate: l,
          maxDate: o,
          isStartDate: X,
          isEndDate: J,
          isInRange: W,
          handleDateClick: P,
          setHoveredDate: z,
          isPeriodDisabled: V
        }
      ),
      /* @__PURE__ */ s(
        x,
        {
          days: ht,
          monthLabel: St,
          minDate: l,
          maxDate: o,
          isStartDate: X,
          isEndDate: J,
          isInRange: W,
          handleDateClick: P,
          setHoveredDate: z,
          isPeriodDisabled: V
        }
      )
    ] }),
    (q || y) && /* @__PURE__ */ C(
      "div",
      {
        className: f.popover.quickFilters.base,
        children: [
          /* @__PURE__ */ s(
            "span",
            {
              className: f.popover.quickFilters.title,
              children: "Quick select:"
            }
          ),
          q && /* @__PURE__ */ s(
            Q,
            {
              onClick: () => {
                const t = /* @__PURE__ */ new Date();
                l && t < l || o && t > o || (g(t), h(null), N("end"), A(t), L && 1 >= M && 1 <= m && (E(t, t), Y(!1), g(null), h(null), N(null)));
              },
              disabled: l && /* @__PURE__ */ new Date() < l || o && /* @__PURE__ */ new Date() > o || !1,
              className: f.popover.quickFilters.button,
              color: "outline",
              size: "xs",
              pill: !0,
              children: "Today"
            }
          ),
          q && y && /* @__PURE__ */ s(
            "span",
            {
              className: f.popover.quickFilters.separator,
              children: "|"
            }
          ),
          y && et.map((t) => /* @__PURE__ */ s(
            Q,
            {
              color: "outline",
              size: "xs",
              pill: !0,
              onClick: () => Ft(t.days),
              disabled: t.days < M || t.days > m,
              className: Ot(
                f.popover.quickFilters.button,
                $ === t.days && f.popover.quickFilters.activeButton
              ),
              children: t.label
            },
            t.days
          ))
        ]
      }
    ),
    /* @__PURE__ */ C("div", { className: f.popover.footer.base, children: [
      rt ? /* @__PURE__ */ s(
        It,
        {
          selecting: p,
          minPeriodDays: M,
          maxPeriodDays: m,
          start: B(R),
          end: B(U),
          showDaysCount: j,
          periodDays: $
        }
      ) : /* @__PURE__ */ s("div", {}),
      /* @__PURE__ */ s(
        bt,
        {
          autoApply: L,
          onCancel: Yt,
          onConfirm: vt,
          selecting: p,
          tempStart: a,
          tempEnd: v
        }
      )
    ] })
  ] });
  return _ && O && !H ? /* @__PURE__ */ s("div", { className: f.popover.root.base, children: Z() }) : /* @__PURE__ */ C(qt, { open: ut, onOpenChange: Y, children: [
    H && /* @__PURE__ */ s(
      Et,
      {
        startDate: D(F),
        endDate: D(I),
        showDaysCount: j,
        periodDays: $
      }
    ),
    /* @__PURE__ */ s(
      yt,
      {
        className: f.popover.root.base,
        align: lt,
        side: st,
        sideOffset: at,
        children: Z()
      }
    )
  ] });
};
export {
  Jt as PeriodDatePicker,
  Jt as default
};
